export const LOW_RATING_THRESHOLD = 3;

export const MAX_OBSERVATION_LENGTH = 255;

export const RATING_HINTS = ['Muito ruim', 'Ruim', 'Regular', 'Bom', 'Excelente'];

export const REASONS_FIELD_BY_RATING_FIELD = {
	clinic_rating: 'clinic_reasons',
	doctor_rating: 'doctor_reasons'
};

export const CLINIC_REASONS = [
	{ value: 'wait_time', label: 'Tempo de espera' },
	{ value: 'reception', label: 'Recepção' },
	{ value: 'scheduling', label: 'Agendamento' },
	{ value: 'facility_structure', label: 'Estrutura do local' },
	{ value: 'cleanliness', label: 'Limpeza' }
];

export const DOCTOR_REASONS = [
	{ value: 'appointment_duration', label: 'Tempo de consulta' },
	{ value: 'explanation_clarity', label: 'Clareza nas explicações' },
	{ value: 'attentiveness', label: 'Atenção e escuta' },
	{ value: 'punctuality', label: 'Pontualidade' }
];
